export default class InstructorsGroupLessonPrice {
    public PriceForOne: number = 0;
}